package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_01_10_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At breakfast, the heroes don’t see Lornella Dabrin the innkeeper — a human man has taken over the morning shift.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes Wind Walk to the Fox estate. Fox has offered the heroes a steep discount on a bastion in Freeburg that they plan to view this morning. Fox changes into armor, and they take two horse-drawn carriages to the bastion. The property spans 160 acres (65 hectares). Its walls crumble in places, and nature has already begun to reclaim what was once tended. A two‑level main hall with a dozen or so rooms anchors the grounds, watched over by a four‑story tower. Several ponds dot the overgrown fields. Fox says this land has been in his family for years.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Fox had previously stated that the property was worth 200,000 gold, but he would sell it to the heroes for 50,000 gold. Fox now offers a zero interest loan with a down payment of only 20,000 gold. The heroes have immense wealth and could easily pay for the property in full but decide to pay just the down payment so as to not reveal the extent of their wealth. Annette takes the deed.")
    }
}
